export { Prism } from 'prism-react-renderer'
import { Prism } from 'prism-react-renderer'

globalThis.Prism = Prism

// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-markup-templating')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-php')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-java')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-bash')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-ruby')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-csharp')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-cpp')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-perl')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-scala')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-haskell')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-elixir')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-dart')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-lua')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-r')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-powershell')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-docker')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-nginx')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-makefile')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-protobuf')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-graphql')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-toml')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-ini')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-diff')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-scss')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-sass')
// @ts-expect-error - prismjs components don't have type definitions
await import('prismjs/components/prism-less')
